export default "__VITE_ASSET__DGoLHGDB__"